module.exports = __webpack_public_path__ + "static/img/patent_5.979dc79b.png";